import { render } from "./AppHeader.vue?vue&type=template&id=294b5c08"
const script = {}

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b3655c94b52f2edce08bd59b38cc948d/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__